import React, { FC } from 'react';
import { Unstable_Grid2 as Grid } from '@mui/material';

import { Network } from 'api/public';
import { Capability } from 'components';
import { useContent } from 'hooks';

import PublicShareTextBox from '../public/PublicShareTextBox';
import { isPhotoOnly } from '../helpers';

const PublicShareCard: FC = () => {
  const content = useContent();

  const photoOnly = isPhotoOnly(content);

  return (
    <Grid container spacing={2}>
      <Grid xs={12}>
        <Capability name="Sharing.Function.ShareToTwitter">
          <PublicShareTextBox network={Network.Twitter} />
        </Capability>
      </Grid>

      <Grid xs={12}>
        <Capability name="Sharing.Function.ShareToLinkedIn">
          <PublicShareTextBox network={Network.Linkedin} />
        </Capability>
      </Grid>

      <Grid xs={12}>
        {!photoOnly && (
          <Capability name="Sharing.Function.ShareToFacebook">
            <PublicShareTextBox network={Network.Facebook} />
          </Capability>
        )}
      </Grid>
    </Grid>
  );
};

export default PublicShareCard;
